module.exports = __webpack_public_path__ + "img/horizontal_6_3_6005.c9c27fe9.png";